import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SafeHtmlPipe } from 'src/app/templates/safe.pipe';
import { AppService } from '../../app.service';
import { ContentService } from '../../services/content.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-results-strengths',
  templateUrl: './results-strengths.component.html',
  styleUrls: ['./results-strengths.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SafeHtmlPipe, CommonModule],
})
export class ResultsStrengthsComponent implements OnInit {
  isApiDataLoaded: boolean = false;
  reportContent: string;

  constructor(
    private appService: AppService,
    private contentService: ContentService,
  ) {}

  ngOnInit() {
    let mbtiType = this.appService.mbtiType;

    this.contentService.getReport('TeamsIndividualStrengths', mbtiType).subscribe((data) => {
      this.reportContent = data.content;
      this.isApiDataLoaded = true;
    });
  }
}
